import { Stack } from 'expo-router';
import Head from 'expo-router/head';
import { useIntl } from 'react-intl';

import MenuScreenV2 from '@fhs/routing/src/routes/v2/menu/(menu)';
import StoreSelected from '@fhs-legacy/frontend/src/components/store-selected';
import MainMenu from '@fhs-legacy/frontend/src/pages/main-menu';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { isNative } from '@fhs-legacy/frontend/src/utils/environment';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function MenuIndexPage() {
  const { formatMessage } = useIntl();

  // TODO(simplified-menu): Remove when simplified menu is out of beta
  const enableSimplifiedMenuBeta = useFlag<boolean>(LaunchDarklyFlag.ENABLE_SIMPLIFIED_MENU_BETA);
  if (enableSimplifiedMenuBeta) {
    return <MenuScreenV2 />;
  }

  return (
    <StoreSelected>
      <Stack.Screen options={{ headerShown: isNative }} />
      <Head>
        <title>{`${formatMessage({ id: 'menu' })} - Firehouse Subs`}</title>
      </Head>
      <MainMenu />
    </StoreSelected>
  );
}
